<style>
#videoRegisterModal .v--modal-box.v--modal {
  min-height: 470px !important;
  min-width: 750px !important;
}
#videoRegisterModal .modal__content {
  height: calc(100% - 60px) !important;
}
#videoRegisterModal .modal__footer {
  display: none;
}
</style>

<template>
  <Modal
    modalName="videoRegisterModal"
    title="REJESTR INSPEKCJI WIDEO"
    @closed="close"
    :buttons="[]"
    :register="register"
  >
    <VideoInspectionsTable />
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import VideoInspectionsTable from "../../table/VideoInspectionsTable";

export default {
  components: {
    Modal,
    VideoInspectionsTable
  },
  data: () => ({
    register: true
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  methods: {
    close() {
      if(!this.activeModals.includes('videoInspectionCardModal')) this.$root.$emit('removeMapLayer')
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/viewer/video/modals/VideoRegister.vue